module.exports = __webpack_public_path__ + "static/media/Perum Peruthani.00c0e319.webp";